import axios from 'axios';

const { REACT_APP_BASE_URL } = process.env

const getTKGMIl = async (token: any) => {
    return axios.get(REACT_APP_BASE_URL + `rest/v1/external-services/parsel/il`, { params: { token: token } });
}

const getTKGMIlce = async (ilID: number, token: any, name: string) => {
    return axios.get(REACT_APP_BASE_URL + `rest/v1/external-services/parsel/ilce/${ilID}/${name}`, { params: { token: token } });
}

const getTKGMMahalle = async (ilceID: number, token: any, name: string) => {
    return axios.get(REACT_APP_BASE_URL + `rest/v1/external-services/parsel/mahalle/${ilceID}/${name}`, { params: { token: token } });
}

const getParsel = async (body: any, token: any) => {
    return axios.post(REACT_APP_BASE_URL + `rest/v1/external-services/parsel/parselInfo`, body, { params: { token: token } });
}

const getParselPoint = async (x: number, y: number, token: any) => {
    return axios.get(REACT_APP_BASE_URL + `rest/v1/external-services/parsel/${x}/${y}`, { params: { token: token } });
}

const getParselArea = async (body: any, token: any) => {
    return axios.post(REACT_APP_BASE_URL + `rest/v1/external-services/parsel/areaInfo`, body, { params: { token: token } });
}

export const ExternalServicesRestApi = {
    getTKGMIl,
    getTKGMIlce,
    getTKGMMahalle,
    getParsel,
    getParselPoint,
    getParselArea
}